import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchColors } from '../api/car-api';
import { fetchAdFeatures } from '../api/ad-api';
import { fetchMunicipalities } from '../api/location-api';
import PropTypes from 'prop-types';

const StaticDataContext = createContext(null);

export const StaticDataProvider = ({ children }) => {
  const [data, setData] = useState({
    colors: null,
    features: null,
    municipalities: null,
  });

  useEffect(() => {
    const load = async () => {
      const cached = localStorage.getItem('static-data');
      if (cached) {
        setData(JSON.parse(cached));
        return;
      }

      const [colorRes, featureRes, municipalityRes] = await Promise.all([
        fetchColors(),
        fetchAdFeatures(),
        fetchMunicipalities(),
      ]);

      const staticData = {
        colors: colorRes?.data,
        features: featureRes?.data,
        municipalities: municipalityRes?.data,
      };

      localStorage.setItem('static-data', JSON.stringify(staticData));
      setData(staticData);
    };

    load();
  }, []);

  return (
    <StaticDataContext.Provider value={data}>
      {children}
    </StaticDataContext.Provider>
  );
};

StaticDataProvider.propTypes = {
  children: PropTypes.object,
};

export const useStaticData = () => useContext(StaticDataContext);
